/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClickGallery
 */
export interface ClickGallery {
    /**
     * 
     * @type {number}
     * @memberof ClickGallery
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ClickGallery
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClickGallery
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClickGallery
     */
    readonly presignedLoginUrl: string;
}

export function ClickGalleryFromJSON(json: any): ClickGallery {
    return ClickGalleryFromJSONTyped(json, false);
}

export function ClickGalleryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickGallery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'presignedLoginUrl': json['presigned_login_url'],
    };
}

export function ClickGalleryToJSON(value?: ClickGallery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
    };
}


